import axios from 'axios';
import * as types from '../constants/ActionTypes';
import * as notifier from '../constants/NotifierTypes';
import Page from '../../lib/page';
import { postChatBotEligibility } from './action-postchatbot-eligibility';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export const preserveFieldData = (formData) => ({
  type: types.PRESERVE_FIELD_DATA,
  payload: formData,
});

export const sendEmailRequest = () => ({
  type: types.SEND_EMAIL,
});

export const receiveEmailSuccessResponse = (options) => ({
  type: types.RECEIVE_EMAIL_RESPONSE,
  payload: notifier.getEmailSentSuccess(options),
});

export const receiveEmailErrorResponse = () => ({
  type: types.RECEIVE_EMAIL_ERROR,
  payload: notifier.functionIsUnavailable,
});

export const goBackToChangeTopicTree = () => ({
  type: types.CANCEL_EMAIL_FORM,
});

export const goBackToCancelEmailForm = () => ({
  type: types.CANCEL_EMAIL_FORM,
});

export const preserveData = (responseData) => (dispatch) => {
  dispatch(preserveFieldData(responseData));
};

export const sendEmail = (options) => (dispatch) => {
  dispatch(sendEmailRequest());
  axios.post('/smarthelp/create-msg', options.emailPayload).then(() => {
    dispatch(receiveEmailSuccessResponse({ hasCommunityAccess: options.hasCommunityAccess, isSmcEnabled: options.isSmcEnabled, desc: options.thankyouPageDescription }));
  }).catch(() => {
    dispatch(receiveEmailErrorResponse());
  });
};

export const cancelEmailForm = () => (dispatch, getState) => {
  const { smcResultKeeper, emailForm } = getState();
  // checking for topic refId or kana code
  const topicRefId = ((smcResultKeeper && smcResultKeeper.topicRefId) || (emailForm && emailForm.kanaCode));
  let postChatBotResponse = '';
  if (topicRefId) {
    // Final Intent call if topic refid exists
    postChatBotResponse = Page.getChatBotEligibilityParams(topicRefId, 'TOPIC');
  } else {
    // default page
    postChatBotResponse = Page.getChatBotEligibilityParams('contactUSpage', 'GENERIC');
  }
  dispatch(postChatBotEligibility(postChatBotResponse));
  dispatch(goBackToCancelEmailForm());
};

export const changeTopicTree = () => (dispatch) => {
  dispatch(cancelEmailForm());
};
